module.exports = __webpack_public_path__ + "static/hero-section-cover-33eec04595882e52c9d00e51091fc867.webp";